//import Chess from '../chess/chessLib'
import $ from 'jquery'
import { plotArrow } from '../utils';

export default class ChessBoard {
  constructor() {
    var that = this;

    $(document).bind('chessBoard-show', function (e, data) {
      that.displayChessBoard(data);
    });

    $(document).bind('chessBoard-hide', function (e, data) {
      that.hideChessBoard()
    }).bind(that);

    $(document).bind('chessBoard-destroy', function (e, data) {
      that.destroyChessBoard();
    }).bind(that);

    $(document).bind('canvas-show', function(e, data) {
      that.showCanvas()
    }).bind(that);
  }

  /**
  * @name displayChessBoard
  * @function
  * @param {config}
  * @description: Display the chess board
  */
  displayChessBoard(config) {
    let chessboard = config.board,
      positionFen = config.positionFen,
      pieceTheme = chessboard.config.pieceTheme;

    chessboard.config.pieceTheme = pieceTheme ? pieceTheme : "img/chesspieces/simple_black_white/{piece}.svg";
    ChessBoard.config = chessboard;

    if (config.hint) {
      $('.right-box-content').append($('.chessboard-container'))
      $('.chessboard-container').addClass('hint-chessboard')
    } else {
      $('.center-box').append($('.chessboard-container'))
      $('#chessVideo, .qa-section-container').removeClass('show').addClass('hide')
      $('.chessboard-container').removeClass('hint-chessboard')
    }

    if (config.heading) {
      $('.castling-head').remove();
      $('.chessboard-container').prepend('<div class="castling-head"> <b>'+config.heading+'</b> </div>')
    }

    let screenWidth = $('.page-body').width(),
     screenHeight = $('.page-body').height();
    if (config.canvas) {
      if (!document.getElementById("myCanvas")) {
        $('.chessboard-container').append(`<canvas id="myCanvas" width=${screenWidth} height=${screenHeight} ></canvas>`);
      }
    } else {
      $('#myCanvas').remove();
    }

    $('.chessboard-container').removeClass('hide').addClass('show-flex');

    ChessBoard.game = positionFen ? new window.Chess(positionFen) : new window.Chess();
    ChessBoard.board = window.ChessBoard('chessBoard', chessboard.config);
    ChessBoard.board.resize();

    //to show arrows in hint chessboard
    if (config.canvas && config.hint) {
      let c = document.getElementById("myCanvas"),
      ctx = c.getContext("2d");
      ctx.clearRect(0, 0, c.width, c.height);
      plotArrow(ctx, config.canvas.from, config.canvas.to, null, null, null, null, 4, 2);
    }

    if (chessboard.afterLoad) {
      chessboard.afterLoad();
    }
  }


/**
  * @name showCanvas
  * @function
  * @param {}
  * @description: show canvas
  */
  showCanvas() {
    let screenWidth = $('.page-body').width(),
      screenHeight = $('.page-body').height();
    $('.chessboard-container').append(`<canvas id="myCanvas" width=${screenWidth} height=${screenHeight} ></canvas>`)
  }

  /**
  * @name hideChessBoard
  * @function
  * @param {}
  * @description: Hide the chess board
  */
  hideChessBoard() {
    $('#chessBoard').html('');
  }

  /**
  * @name destroyChessBoard
  * @function
  * @param {}
  * @description: Destroy the chess board
  */
  destroyChessBoard() {
    if (ChessBoard.board) {
      ChessBoard.board.destroy();
    }
  }
}

ChessBoard.board = null;
ChessBoard.config = null;
ChessBoard.game = null;


// WEBPACK FOOTER //
// ./src/components/chessBoard.js